import React, { useEffect, useRef } from "react";
import { TextContainer, Paragraph } from "../styles/components/Global/Text";
import animations from "./Animations";

const ParagraphText = ({
  text,
  width,
  align,
  size,
  textAlign,
  indent,
  capitalize,
  bold,
  parallax,
  zIndex,
}) => {
  const containerRef = useRef(null);
  useEffect(() => {
    if (parallax) {
      setTimeout(() => {
        animations.parallax(containerRef.current);
      }, 1000);
    }
  }, []);

  return (
    <TextContainer ref={containerRef} $align={align} $zIndex={zIndex} $flex>
      <Paragraph
        $width={width}
        $indent={indent}
        $size={size}
        $textAlign={textAlign}
        $capitalize={capitalize}
        $bold={bold}
        dangerouslySetInnerHTML={{ __html: text }}
      ></Paragraph>
    </TextContainer>
  );
};

ParagraphText.defaultProps = {
  width: "medium",
  align: "center",
  size: "normal",
  textAlign: "center",
  bold: false,
  capitalize: false,
  indent: false,
  parallax: true,
  zIndex: false,
};

export default ParagraphText;
